import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AppService } from '../app.service';
import { messageService } from '../message.service';
import { AuService } from '../qms/au/au.service';
import { qmsService } from '../qms/qms.service';
import { EditorConfig, ST_BUTTONS } from 'ngx-simple-text-editor';

@Component({
  selector: 'app-editor',
  templateUrl: './editor.component.html',
  styleUrls: ['./editor.component.scss']
})
export class EditorComponent implements OnInit{

  isProcessing = false;
  title  :any = "";

  constructor(private appService: AppService, public message: messageService, public dialog: MatDialog, private snackBar: MatSnackBar, public qmsservice: qmsService, public auService: AuService) { }
  
  
  ngOnInit(): void {
  }
  @ViewChild('clobViewPopup', { static: true }) clobViewPopup: TemplateRef<any>;
  visibleClobViewPopup: MatDialogRef<TemplateRef<any>>;

  clobViewPopupConfig = {
    width: '1000px',
    height: 'auto',
    panelClass: 'my-dialog',
    hasBackdrop: true,
    position: { top: '10px' },
    maxWidth: '95vw',
    disableClose: true
  };

  htmlContent : any = "";
  config1: EditorConfig = {
    buttons: ST_BUTTONS,
  };
  config: EditorConfig = {
    buttons: [],
  };
  openEditor(htmlContent : any,title : any) {
    this.title = title;
    this.htmlContent = htmlContent;
    this.visibleClobViewPopup = this.dialog.open(this.clobViewPopup,this.clobViewPopupConfig);
  }

  closeHtmlContent(){
    this.visibleClobViewPopup.close();
  }

  
}
